module.exports = __webpack_public_path__ + "img/ai_help01_img_06.ab9ac084.png";